// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"42":"a29b20b9e0b73af7","911":"445f84d2e942cfdf","977":"c92ee922f471cb2c","980":"9733f92528214c3a"}[chunkId] + ".js";
};